export const menuAll = {
  navMenu: [
    { class: '', link: '/', title: 'Home', desc: '' },
    { class: '', link: '/students', title: 'Students', desc: '' },
    { class: '', link: '/staffs', title: 'Staffs', desc: '' },
    { class: '', link: '/semesters', title: 'Semesters', desc: '' },
    { class: '', link: '/page/about', title: 'About', desc: '' },
    { class: '', link: '/page/college', title: 'College', desc: '' },
    {
      class: '',
      link: '/news-events',
      title: 'News & Events',
      desc: '',
    },
  ],

  socialLinks: [
    {
      class: '',
      link: 'https://chat.whatsapp.com/LfR9x0Ovr8g11VaLzbkoab',
      title: 'Whatsapp',
      desc: '',
    },
    {
      class: '',
      link: 'https://www.facebook.com/groups/revit08/',
      title: 'Facebook',
      desc: '',
    },
    {
      class: '',
      link: 'https://www.messenger.com/t/292059584803306',
      title: 'Messenger',
      desc: '',
    },
  ],
  homeMenu: [
    {
      class: 'students',
      link: '/students',
      title: 'STUDENTS',
      desc: '64 MEMBERS',
    },
    {
      class: 'staffs',
      link: '/staffs',
      title: 'STAFFS',
      desc: 'From All Department',
    },
    {
      class: 'events',
      link: '/page/about',
      title: 'ABOUT',
      desc: 'SINCE 2004',
    },
    {
      class: 'college',
      link: '/page/college',
      title: 'COLLEGE',
      desc: 'Other Links',
    },
  ],
};
